// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { createContext, useContext } from 'react';
export const GroupedControlContext = createContext({
    position: null,
    direction: 'horizontal',
    hasAction: false,
    invalid: false,
    warning: false,
});
export function useGroupedControlContext() {
    return useContext(GroupedControlContext);
}
/**
 * Resets the grouped-control context back to "not in a group" for a subtree.
 *
 * Controls that render caller-supplied content (for example, custom dropdown
 * content) should wrap that content with this provider. Otherwise a nested
 * control rendered inside such a slot would inherit the surrounding group's
 * `position` and incorrectly pick up the grouped-control styling
 * where adjacent borders lose their border radii. The group's validation
 * state (`invalid`/`warning`) is also cleared so nested custom-slot controls
 * never inherit the group's validation styling.
 */
export function ResetGroupedControlContext({ children }) {
    const { direction } = useGroupedControlContext();
    return (React.createElement(GroupedControlContext.Provider, { value: { position: null, direction, invalid: false, warning: false } }, children));
}
//# sourceMappingURL=control-group-context.js.map